import { isEmptyObject } from './objectUtils';

export function capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function removeTrailingSlash(url: string): string {
    return url.endsWith('/') ? url.slice(0, -1) : url;
}

export function getFileNameFromUrl(url: string): string {
    return removeTrailingSlash(url).split('/').pop()?.split('?')?.[0] ?? url;
}

export function nameof(obj: Record<string, unknown>): string {
    return Object.keys(obj)[0];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debugValue(value: any): string {
    if (typeof value === 'undefined')
        return 'undefined';

    if (Array.isArray(value))
        return `Array(${value.length})`;

    if (typeof value === 'object') {
        if (value === null)
            return 'null';

        if (isEmptyObject(value))
            return '{}';
        else
            return '{�}';
    }

    if (typeof value === 'function')
        return '�() {}';

    if (typeof value === 'string')
        return `"${value}"`;

    return value.toString();
}